<template>
  <div class="card flex justify-center rounded-lg">
    <SelectButton
      v-model="selectedLanguage"
      :options="countries"
      optionLabel="name"
      optionValue="value"
      aria-labelledby="custom"
      :allowEmpty="false"
      :placeholder="languageStore.t('app.language')"
      :pt="{
        pcToggleButton: {
          root: {
            // class: `!bg-[rgba(241,245,249,${opacity})] !border-[rgba(241,245,249,${opacity})]`,
            style: {
              backgroundColor: `rgba(241, 245, 249, ${opacity})`,
              borderColor: `rgba(241, 245, 249, ${opacity})`,
            },
          },
        },
      }"
    >
      <template #option="slotProps">
        <img
          :alt="slotProps.option.label"
          :src="`https://flagcdn.com/w80/${slotProps.option.flag}.png`"
          :class="`flag mr-2`"
          style="width: 16px"
        />
        <div class="text-sm">{{ slotProps.option.name }}</div>
      </template>
    </SelectButton>
  </div>
</template>

<script setup lang="ts">
import { enPrimeVueTranslations } from '@/locales/primeVue/en-primevue-translations'
import { esPrimeVueTranslations } from '@/locales/primeVue/es-primevue-translations'
import { ptPrimeVueTranslations } from '@/locales/primeVue/pt-primevue-translations'
import { useLanguageStore } from '@/stores/LanguageStore'
import { Select, SelectButton } from 'primevue'
import { usePrimeVue } from 'primevue/config'
import { onMounted, ref, watch } from 'vue'

const { opacity } = defineProps({
  opacity: {
    type: Number,
    default: 1,
  },
})

const languageStore = useLanguageStore()
const primeVue = usePrimeVue()

const selectedLanguage = ref(languageStore.locale || 'pt')

const localePrimeVue = {
  pt: ptPrimeVueTranslations,
  es: esPrimeVueTranslations,
  en: enPrimeVueTranslations,
}

const countries = ref([
  { name: 'PT', value: 'pt', flag: 'br' },
  { name: 'EN', value: 'en', flag: 'us' },
  { name: 'ES', value: 'es', flag: 'es' },
])

const changeLanguagePrimeVue = (language: (typeof languageStore.availableLocales)[number]) => {
  primeVue.config.locale = localePrimeVue[language as keyof typeof localePrimeVue]
}

watch(selectedLanguage, (newVal) => {
  languageStore.changeLanguage(newVal)
  changeLanguagePrimeVue(newVal)
})
</script>
